import { c as _c } from "react/compiler-runtime";
import { postHostedUserConsent } from '@onefootprint/fetch-hosted';
import { useMutation } from '@tanstack/react-query';
import { Trans, useTranslation } from 'react-i18next';
export const usePostTermsAndConditionsConsentMutation = identifyToken => {
  const $ = _c(5);
  const {
    t
  } = useTranslation("identify");
  let t0;
  if ($[0] !== t) {
    t0 = t(_temp);
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const consentText = t0;
  let t1;
  if ($[2] !== consentText || $[3] !== identifyToken) {
    t1 = {
      mutationFn: async () => {
        await postHostedUserConsent({
          body: {
            content: consentText,
            kind: "terms_and_conditions"
          },
          headers: {
            "X-Fp-Authorization": identifyToken
          }
        });
      }
    };
    $[2] = consentText;
    $[3] = identifyToken;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return useMutation(t1);
};
const LegalFooter = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <p className="text-caption-2 text-tertiary text-center"><Trans ns="identify" i18nKey={_temp2} components={{
        termsLink: <a href="https://www.onefootprint.com/terms-of-service" rel="noopener noreferrer" target="_blank" className="text-accent" />,
        privacyPolicyLink: <a href="https://www.onefootprint.com/privacy-policy" rel="noopener noreferrer" target="_blank" className="text-accent" />
      }} /></p>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default LegalFooter;
function _temp($) {
  return $["legal-footer"];
}
function _temp2($) {
  return $["legal-footer"];
}